import './Footer.css'

const Footer = () => {
    return (
       <footer>
        <h2>I Love u</h2>
        <img src="./imagens/Logo.svg" alt="Banner img"/>
        <p>&copy; 2023 Sandro M. da Cunha. Todos os direitos reservados.</p>
       </footer>
    )
}

export default Footer;